/* MOT Life Coach landing page.

   Ported from the standalone page's inline script. Two changes:
   the scroll-progress hairline is gone with the page's own sticky header,
   and everything is scoped per wrapper so the theme editor can re-init a
   section without touching another instance on the page. */
(function () {
  function reveal(root) {
    if (!root.hasAttribute('data-js')) return;
    try {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('in');
              io.unobserve(en.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
      root.querySelectorAll('.rv').forEach(function (e) {
        io.observe(e);
      });
    } catch (e) {
      /* Any failure drops the gate so every section renders unrevealed
         rather than staying at opacity 0. */
      root.removeAttribute('data-js');
    }
  }

  function lightbox(root) {
    var dlg = root.querySelector('.lb');
    var open = root.querySelector('.cert-figure');
    var close = root.querySelector('.lb .x');
    if (!dlg || !open || typeof dlg.showModal !== 'function') return;
    open.addEventListener('click', function () {
      dlg.showModal();
    });
    if (close) {
      close.addEventListener('click', function () {
        dlg.close();
      });
    }
    dlg.addEventListener('click', function (e) {
      if (!e.target.closest('.lb-inner')) dlg.close();
    });
  }

  /* Send a plan straight to its destination.

     The form already carries return_to, which is all Shopify needs -- but the
     store runs a cart-drawer app (Kaching) that hijacks every cart/add form
     submit into its own fetch and opens a drawer, so the native redirect never
     runs. Handling the click ourselves means no submit event is ever
     dispatched, so nothing else gets the chance to swallow it.

     Everything here is progressive enhancement: with scripting off the form
     posts natively and return_to still lands the buyer in the right place. */
  function directCheckout(root) {
    root.querySelectorAll('form.mlc-plan-form').forEach(function (form) {
      var btn = form.querySelector('button[type="submit"]');
      var returnTo = form.querySelector('input[name="return_to"]');
      returnTo = returnTo && returnTo.value;
      /* 'back' means the merchant chose to keep buyers on the page; leave the
         drawer app to it rather than taking the click away. */
      if (!btn || !returnTo || returnTo === 'back') return;

      btn.addEventListener('click', function (e) {
        var id = form.querySelector('input[name="id"]');
        if (!id || !window.fetch) return;
        e.preventDefault();

        var qty = form.querySelector('input[name="quantity"]');
        var plan = form.querySelector('input[name="selling_plan"]');
        var data = new FormData();
        data.append('id', id.value);
        data.append('quantity', (qty && qty.value) || '1');
        if (plan && plan.value) data.append('selling_plan', plan.value);

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(function () {
            window.location.assign(returnTo);
          })
          .catch(function () {
            /* form.submit() does not fire submit handlers, so the native post
               and its return_to survive even with the drawer app present. */
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            form.submit();
          });
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.mlcReady === 'true') return;
    root.dataset.mlcReady = 'true';
    reveal(root);
    lightbox(root);
    directCheckout(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mlc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
